import { ConversationFolderLabel } from '@indeed/messaging-react';

export const getFilterFromConversationFolderLabel = (
    label: ConversationFolderLabel
): string | undefined => {
    switch (label) {
        case ConversationFolderLabel.Inbox:
            return 'Inbox';
        case ConversationFolderLabel.Archive:
            return 'Archive';
        case ConversationFolderLabel.Spam:
            return 'Spam';
        default:
            return 'Inbox';
    }
};

export const getConversationFolderLabelFromFilter = (
    filter: string | null
): ConversationFolderLabel | undefined => {
    switch (filter) {
        case 'Inbox':
            return ConversationFolderLabel.Inbox;
        case 'Archive':
            return ConversationFolderLabel.Archive;
        case 'Spam':
            return ConversationFolderLabel.Spam;
        default:
            return ConversationFolderLabel.Inbox;
    }
};
